import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { Link } from '@bd/bdcore-named-routes';
import { Image } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { ActivateMapPin } from '@bd/bdcore-data/build/Map';
// import getCommunityPriceString from '../getCommunityPriceString';

function CommunityCard({ community, homes, plans, hideMapPin }) {
  return (
    <div className="card CommunityCard">
      <Link
        name="community-detail"
        community={community}
      >
        <div className={`card-media ${community.is_sovereign ? 'sovereign' : ''}`}>
          {
            community.photos.length > 0 &&
            <Image
              src={get(community, 'photos[0].contentUrl', '')}
              style={{ maxWidth: '100%' }}
              alt={get(community, 'name')}
              width={400}
              height={250}
              exact
            />
          }
          {
            community.photos.length === 0 &&
            <img src="/images/comming-soon.jpg" alt="Circle Arrow Button" className="card-img-top" />
          }
        </div>
        <div className="card-content">
          <div className="d-flex top-row">
            <div className={`${hideMapPin ? 'col-12 p-0' : 'col-10 p-0'}`}>
              <h4>{community.name}</h4>
              <h5>{community.address.addressLocality}, {community.address.addressRegion}</h5>
            </div>
            {
              !hideMapPin &&
              <div className="col-2 p-0">
                <div className="text-right">
                  <ActivateMapPin itemId={community._id}>
                    <img src="/images/icon-map-pin-charcoal.svg" alt="Map Pin" />
                  </ActivateMapPin>
                </div>
              </div>
            }
          </div>
          <ul>
            {
              (
                !!get(community, 'priceHigh')
                || !!get(community, 'priceLow')
              ) &&
              <li>
                Price Range: {' '}
                {
                  !!get(community, 'priceLow') &&
                  numeral(get(community, 'priceLow', '')).format('$0,0')
                }
                {
                  !!get(community, 'priceHigh') &&
                  !!get(community, 'priceLow') &&
                  ' - '
                }
                {
                  !!get(community, 'priceHigh') &&
                  numeral(get(community, 'priceHigh', '')).format('$0,0')
                }
              </li>
            }
            {
              !!get(community, 'sqftHigh') &&
              !!get(community, 'sqftLow') &&
              <li>
                <span>
                  {
                    numeral(get(community, 'sqftLow')).format('0,0')
                  }
                  -
                  {
                    numeral(get(community, 'sqftHigh')).format('0,0')
                  }{' '}
                  SQ FT
                </span>
              </li>
            }
            <li>
              {get(community, 'schools[0].district')}
            </li>
          </ul>
        </div>
        <div className="card-footer">
          <ul>
            <li><span>{plans.length}</span> Floor Plans</li>
            <li><span>{homes.length}</span> Quick Move-In Homes</li>
            <li>
              <img src="/images/icon-circle-arrow-orange.svg" alt="" height="26" width="26" />
            </li>
          </ul>
        </div>
      </Link>
    </div>
  );
}

CommunityCard.propTypes = {
  community: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
  hideMapPin: PropTypes.bool,
};

CommunityCard.defaultProps = {
  homes: [],
  plans: [],
  hideMapPin: false,
};

export default withData(
  {
    community: true,
    homes: true,
    plans: true,
  },
  {
    required: {
      community: true,
    },
  },
)(CommunityCard);



// WEBPACK FOOTER //
// ./src/pages/Communities/CommunityCard/index.js